import { useSnackbar } from "../../../utils/notificacoes"
import React, { useCallback, useEffect, useReducer, useState } from "react"
import {
    limparErrosFoody,
    obterIntegracaoFoody,
    salvarTokenFoody,
    testarIntegracaoFoody,
} from "../../../services/integracaoFoodyDelivery"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { IntegracaoFoodyDeliveryInicial } from "../models/integracaoFoodyDeliveryModel"
import { IntegracaoFoodyDeliveryActionsTypes } from "./integracaoFoodyDeliveryActions"
import { IntegracaoFoodyDeliveryContext } from "./IntegracaoFoodyDeliveryContext"
import { integracaoFoodyDeliveryReducer } from "./integracaoFoodyDeliveryReducer"

export function IntegracaoFoodyDeliveryContextProvider({
    children,
}: {
    children: React.ReactNode
}) {
    const [dados, dispatch] = useReducer(
        integracaoFoodyDeliveryReducer,
        IntegracaoFoodyDeliveryInicial
    )
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)
    const { enqueueSnackbar } = useSnackbar()

    const alertStart = (msg: string, tipo: "success" | "error" | "info") => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterIntegracaoFoody(
                "Basic Z3VzdGF2b2hkb3NyZWlzQGdtYWlsLmNvbToyMDE4TGltb25hZGE="
            )
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar")
            } else {
                setErroCarregamento(null)
                dispatch({ type: IntegracaoFoodyDeliveryActionsTypes.CARREGAR, payload: response })
            }
        } catch {
            setErroCarregamento("Erro ao carregar")
        } finally {
            setLoading(false)
        }
    }

    const salvarToken = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await salvarTokenFoody(
                "Basic Z3VzdGF2b2hkb3NyZWlzQGdtYWlsLmNvbToyMDE4TGltb25hZGE=",
                dados.token
            )
            if ("retornoErro" in response) {
                alertStart(response.mensagem || "Erro ao salvar token", "error")
            } else {
                alertStart("Token Foody Delivery salvo.", "success")
            }
        } finally {
            setLoading(false)
        }
    }, [dados.token])

    const testarIntegracao = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await testarIntegracaoFoody(
                "Basic Z3VzdGF2b2hkb3NyZWlzQGdtYWlsLmNvbToyMDE4TGltb25hZGE="
            )
            if ("retornoErro" in response) {
                alertStart(response.mensagem || "Erro ao testar integração", "error")
            } else {
                dispatch({
                    type: IntegracaoFoodyDeliveryActionsTypes.REGISTRAR_TESTE,
                    payload: {
                        ativa: response.ativa,
                        mensagem: response.mensagem,
                        erros: response.erros,
                    },
                })
                alertStart(response.mensagem, response.ativa ? "success" : "error")
            }
        } finally {
            setLoading(false)
        }
    }, [])

    const limparErros = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await limparErrosFoody(
                "Basic Z3VzdGF2b2hkb3NyZWlzQGdtYWlsLmNvbToyMDE4TGltb25hZGE="
            )
            if (response && "retornoErro" in response) {
                alertStart(response.mensagem || "Erro ao limpar erros", "error")
            } else {
                dispatch({ type: IntegracaoFoodyDeliveryActionsTypes.LIMPAR_ERROS })
                alertStart("Histórico de erros limpo.", "success")
            }
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        carregar()
    }, [])

    return (
        <IntegracaoFoodyDeliveryContext.Provider
            value={{
                dados,
                dispatch,
                erroCarregamento,
                salvarToken,
                testarIntegracao,
                limparErros,
            }}
        >
            <Loading />
            {children}
        </IntegracaoFoodyDeliveryContext.Provider>
    )
}
